import { createContext, useCallback, useState } from "react";
import { LocalStorageKeys } from "@/common/browserStorage/constants";
import { getStorageValue } from "@/common/browserStorage/utils";
import { ErrorMessageType } from "@/common/types/app";
import { DEFAULT_LOCALE, Locales } from "@/lang/types";

interface AppContextProps {
  lang: Locales;
  setLang: () => void;
  errorMessage: ErrorMessageType;
  setErrorMessage: (message: ErrorMessageType) => void;
}

const localStoreLang = getStorageValue<Locales>(
  LocalStorageKeys.Locale,
  DEFAULT_LOCALE,
);

export const AppContext = createContext<AppContextProps>({
  lang: localStoreLang,
  setLang: () => {},
  errorMessage: null,
  setErrorMessage: () => {},
});

export const useAppContext = () => {
  const [lang, setLang] = useState<Locales>(localStoreLang);
  const [errorMessage, setErrorMessage] = useState<ErrorMessageType>(null);

  const setLangCallback = useCallback(() => {
    setLang((prev) => {
      return prev === Locales.ru ? Locales.kz : Locales.ru;
    });
  }, []);

  return {
    lang,
    setLang: setLangCallback,
    errorMessage,
    setErrorMessage,
  };
};
